import BarChartIcon from "@material-ui/icons/BarChart";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ChatIcon from "@material-ui/icons/ChatOutlined";
import CodeIcon from "@material-ui/icons/Code";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import FolderIcon from "@material-ui/icons/FolderOutlined";
import DashboardTwoToneIcon from "@material-ui/icons/DashboardTwoTone";
import GradeTwoTone from "@material-ui/icons/GradeTwoTone";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LockOpenIcon from "@material-ui/icons/LockOpenOutlined";
import MailIcon from "@material-ui/icons/MailOutlined";
import PresentToAllIcon from "@material-ui/icons/PresentToAll";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";
import PersonIcon from "@material-ui/icons/PersonOutlined";
import ReceiptIcon from "@material-ui/icons/ReceiptOutlined";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

var iconsMap = {
  BarChartIcon: BarChartIcon,
  CalendarTodayIcon: CalendarTodayIcon,
  ChatIcon: ChatIcon,
  CodeIcon: CodeIcon,
  DashboardIcon: DashboardIcon,
  ErrorIcon: ErrorIcon,
  FolderIcon: FolderIcon,
  DashboardTwoToneIcon: DashboardTwoToneIcon,
  GradeTwoTone: GradeTwoTone,
  ListAltIcon: ListAltIcon,
  LockOpenIcon: LockOpenIcon,
  MailIcon: MailIcon,
  PresentToAllIcon: PresentToAllIcon,
  PeopleIcon: PeopleIcon,
  PersonIcon: PersonIcon,
  ReceiptIcon: ReceiptIcon,
  SettingsIcon: SettingsIcon,
  ViewModuleIcon: ViewModuleIcon,
};

export default [
  {
    content: JSON.parse(
      `[
  {
    
        "label": "प्रशिक्षण प्रकार",
        "description": "This is setting section, Here you can change the settings",
        "to": "/admin/trainings-type"
      
  },
  {
    
    "label": "प्रशिक्षण",
    "description": "This is setting section, Here you can change the settings",
    "to": "/admin/trainings"
  
},
  {
    
    "label": "प्रशिक्षक",
    "description": "This is setting section, Here you can change the settings",
    "to": "/admin/trainer"
  
},
{
    
  "label": "लागत व्यवस्थापन",
  "description": "This is setting section, Here you can change the settings",
  "to": "/admin/costManagement"

},
{
  "label": "ईमेल टेम्पलेट",
  "description": "",
  "to": "/admin/email/template"
},
{
  "label": "रिपोर्ट",
  "description": "",
  "to": "/admin/report"
},  

  {
        "label": "सेटिंग्स",
        "description": "This is setting section, Here you can change the settings",
        "to": "/admin/setting/generalSetting"
     
  }

]`,
      (key, value) => {
        if (key === "icon") {
          return iconsMap[value];
        } else {
          return value;
        }
      }
    ),
  },
];

// {
//   "label": "Search",
//   "icon": "SettingsIcon",
//   "permission":"setting-edit",

//   "content": [
//     {
//       "label": "Search",
//       "description": "This is setting section, Here you can change the settings",
//       "to": "/admin/Setting"
//     }
//   ]
// },

// {
//   "label": "प्रयोगकर्ता प्रबन्धन",
//     "description": "",
//     "to": "/admin/users"
// },
// {
//   "label": "भूमिका प्रबन्धन",
//     "description": "",
//     "to": "/admin/roles"
// },
